import { OnInit, Input, Component,AfterViewInit } from '@angular/core';

@Component({
        selector: 'dodger-blue-header',
        templateUrl:'app.dodgerblue.header.html'
})
export class DodgerBlueHeaderComponent implements OnInit
{
    @Input() SectionDetailsList: any;
    @Input() TestInfo: any;
    public SectionDetails: any;
    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/app/Test/Headers/Themes/DodgerBlue/app.dodgerblue.ts